/** Full detail shape for /case-studies/:slug (matches CaseStudiesDetails). */
export function createCaseStudyDetailTemplate(id, title = 'Case Study') {
  return buildCaseStudyDetailShape(title);
}

function buildCaseStudyDetailShape(title = 'Case Study') {
  return {
    hero: {
      imageSrc: '',
      imageAlt: title,
      primaryBadge: '',
      secondaryBadge: '',
      title: String(title).toUpperCase(),
      subtitle: '',
      description: '',
    },
    challenge: {
      heading: 'THE CHALLENGE',
      body: '',
    },
    alert: {
      title: 'Key risk',
      body: '',
    },
    techStack: [],
    phases: [
      {
        title: 'PHASE ONE',
        bodyLines: ['Add phase description here.'],
        imageSrc: '',
        imageAlt: 'Phase one',
      },
      {
        title: 'PHASE TWO',
        bodyLines: ['Add phase description here.'],
        imageSrc: '',
        imageAlt: 'Phase two',
      },
    ],
    impact: [
      { label: 'Metric label', value: '0%', footnote: 'Describe the outcome.' },
    ],
    ltsv: {
      title: 'LONG TERM STRATEGIC VALUE',
      cards: [
        { title: 'Strategic value', text: 'Describe long-term impact.' },
      ],
    },
    testimonial: {
      quote: '',
      name: '',
      role: '',
      avatarSrc: '',
    },
  };
}

/** Fill missing fields so admin drafts and JSON edits never crash the detail page. */
export function isCaseStudyDetailConfigured(detail) {
  if (!detail?.hero) return false;
  const desc = (detail.hero.description || '').trim();
  const challenge = (detail.challenge?.body || '').trim();
  return desc.length > 40 || challenge.length > 40;
}

export function normalizeCaseStudyDetail(detail, slug = '') {
  const tpl = buildCaseStudyDetailShape(slug || 'Case Study');
  if (!detail || typeof detail !== 'object') return tpl;

  const rawPhases = Array.isArray(detail.phases) ? detail.phases : [];
  const phases =
    rawPhases.length >= 2
      ? rawPhases.map((p, i) => ({
          title: p?.title || tpl.phases[i]?.title || `PHASE ${i + 1}`,
          bodyLines: Array.isArray(p?.bodyLines) ? p.bodyLines : tpl.phases[i]?.bodyLines || [],
          imageSrc: p?.imageSrc || '',
          imageAlt: p?.imageAlt || `Phase ${i + 1}`,
        }))
      : tpl.phases;

  const impact = Array.isArray(detail.impact) && detail.impact.length ? detail.impact : tpl.impact;
  const ltsvCards = detail.ltsv?.cards;
  const ltsv =
    Array.isArray(ltsvCards) && ltsvCards.length
      ? { title: detail.ltsv.title || tpl.ltsv.title, cards: ltsvCards }
      : tpl.ltsv;

  return {
    hero: { ...tpl.hero, ...(detail.hero || {}) },
    challenge: { ...tpl.challenge, ...(detail.challenge || {}) },
    alert: { ...tpl.alert, ...(detail.alert || {}) },
    techStack: Array.isArray(detail.techStack) ? detail.techStack : [],
    phases,
    impact,
    ltsv,
    testimonial: { ...tpl.testimonial, ...(detail.testimonial || {}) },
  };
}
